import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';
import React, { useState, useEffect, useRef } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import { ToastContainer, toast } from "react-toastify";
import "./table.css"
import EditModal from './EditModal';
import { useDegreeStore } from '../../stores';
import DeleteModal from './DeleteModal';
import { handleXhrError } from '../../utils';
const MySwal = withReactContent(Swal);
const sortCaretEle = (order, column) => {
  const Up = () => <span style={{ content: '', borderBottom: 0, borderTop: "4px dashed" }} className='caret'></span>
  const Down = () => <span style={{ content: '', borderTop: 0, borderBottom: "4px dashed" }} className='caret'></span>
  if (!order) return (<span>&nbsp;&nbsp;<Up />&ensp;<Down /></span>);
  else if (order === 'asc') return (<span>&nbsp;&nbsp;<Down /></span>);
  else if (order === 'desc') return (<span>&nbsp;&nbsp;<Up /></span>);
  return null;
}
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const headerSortingStyle = { backgroundColor: '#c8e6c9' };
const Table = (props) => {
  const degrees = useDegreeStore(state => state.degrees)
  const addAllDegrees = useDegreeStore(state => state.addAllDegrees)
  const addDegree = useDegreeStore(state => state.addDegree)
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const deleteRef = useRef({});
  const [editableRow, setEditableRow] = useState(null);
  // const [degrees, setDegrees] = useState([Alldegrees]);

  useEffect(() => {
    window.$.ajax({
      type: "get",
      url: "/api/course/degrees",
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addAllDegrees(response.degrees);
      },
      statusCode: {

        404: function () {

          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }, []);
  const updateDegree = (data) => {
    window.$.ajax({
      type: "put",
      url: "/api/super-admin/degrees/" + data._id,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        name: data.name,
        duration: data.duration,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        console.log("success")
        MySwal.fire("Degree successfully updated");
        // addDegree(response)
        setOpenModal(false);
      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }
  const options = {
    // pageStartIndex: 0,
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true
  };
  const columns = [
    // {
    //   dataField: '_id',
    //   text: 'SL.No',
    //   sort: true,
    //   sortCaret: sortCaretEle,
    //   headerSortingStyle: headerSortingStyle
    // },
    // 
    {
      dataField: 'name',
      text: 'Degree',
      sort: true,
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle
    },
    {
      dataField: 'duration',
      text: 'No. of years',
      sort: true,
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return <span style={{ color: "blue" }} title={content}>{content}</span>
      }
    },
    {
      dataField: 'semesters',
      sort: true,
      text: 'No. of semesters',
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return <>{row.duration * 2}</>
      }
    },
    {
      dataField: 'edit',
      text: '',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-primary' onClick={(e) => { setEditableRow(row); setOpenModal(true); e.preventDefault(); }}>Edit</button>
        )
      }
    },
    {
      dataField: 'addbranch',
      text: '',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <Link to={`addbranch/${row._id}`}>AddBranch</Link>
        )
      }
    },
    {
      dataField: 'delete',
      text: '',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-danger' onClick={(e) => { deleteRef.current = row; setOpenDeleteModal(true); e.preventDefault(); }}>Delete</button>
        )
      }
    }
  ];
  const afterSaveCell = (oldVal, newVal) => {
    console.log(oldVal);
    console.log(newVal);
  }
  // const selectRow = {
  //     mode: 'radio',
  //     clickToSelect: true,
  //     clickToEdit: true
  //   };
  return (
    <>
      {/* <ToastContainer /> */}
      <EditModal show={openModal} row={editableRow} updateDegree={updateDegree} onClose={() => setOpenModal(false)} degrees={degrees} />
      <DeleteModal open={openDeleteModal} ref={deleteRef} onClose={() => setOpenDeleteModal(false)} mode="degree" />
      <BootstrapTable
        keyField="_id"
        data={degrees}
        columns={columns}
        pagination={paginationFactory(options)}
        cellEdit={cellEditFactory({ mode: 'click', blurToSave: true, afterSaveCell })}
        striped
        hover
        headerClasses='tableHead'
        condensed
        bordered={false}
      />
    </>
  );
}
export default Table;